import React from 'react'
import { IIconProps } from 'Interfaces'

export function ListViewIcon(props: IIconProps) {
    return (
        <svg width={props.width ?? 16} height={props.height ?? 16} viewBox="0 0 21 21" fill={props.color ?? "currentColor"}>
            <path d="M20.3077 1.84615H7.38461V3.69231H20.3077V1.84615Z" />
            <path d="M20.3077 9.23077H7.38461V11.0769H20.3077V9.23077Z" />
            <path d="M20.3077 16.6154H7.38461V18.4615H20.3077V16.6154Z" />
            <path d="M0 14.7692V20.3077H5.53846V14.7692H0ZM3.69231 18.4615H1.84615V16.6154H3.69231V18.4615Z" />
            <path d="M0 7.38461V12.9231H5.53846V7.38461H0ZM3.69231 11.0769H1.84615V9.23077H3.69231V11.0769Z" />
            <path d="M0 0V5.53846H5.53846V0H0ZM3.69231 3.69231H1.84615V1.84615H3.69231V3.69231Z" />
        </svg>
    )
}
